// extracted by mini-css-extract-plugin
module.exports = {"container":"experience-module--container--3wxn- layout--module--3QxU_","panel":"experience-module--panel--2tnK0 layout--panel--1IXtI","clients":"experience-module--clients--3TNg3"};